export const industries = [
  {
    id: 'real-estate',
    icon: 'Building2',
    title: { en: 'Real Estate', ar: 'العقارات' },
    blurb: {
      en: 'Property sites, lead funnels, and listing systems.',
      ar: 'مواقع عقارية احترافية ومسارات جذب عملاء وأنظمة عرض عقاري.',
    },
  },
  {
    id: 'logistics',
    icon: 'Truck',
    title: { en: 'Logistics', ar: 'اللوجستيات' },
    blurb: {
      en: 'Ops dashboards, tracking, and workflow automation.',
      ar: 'لوحات تشغيل وتتبع شحنات وأتمتة لسير العمل التشغيلي.',
    },
  },
  {
    id: 'ecommerce',
    icon: 'ShoppingBag',
    title: { en: 'E-commerce', ar: 'التجارة الإلكترونية' },
    blurb: {
      en: 'Stores, payments, and scalable product catalogs.',
      ar: 'متاجر إلكترونية وبوابات دفع وكتالوجات منتجات قابلة للتوسع.',
    },
  },
  {
    id: 'education',
    icon: 'GraduationCap',
    title: { en: 'Education', ar: 'التعليم' },
    blurb: {
      en: 'Learning platforms, CMS, and student workflows.',
      ar: 'منصات تعليمية وأنظمة محتوى وإدارة رحلة المتعلم.',
    },
  },
  {
    id: 'healthcare',
    icon: 'HeartPulse',
    title: { en: 'Healthcare', ar: 'الرعاية الصحية' },
    blurb: {
      en: 'Secure patient-facing sites and internal tools.',
      ar: 'مواقع آمنة للمرضى وأدوات داخلية تدعم فرق الرعاية.',
    },
  },
  {
    id: 'finance',
    icon: 'Landmark',
    title: { en: 'Finance', ar: 'الخدمات المالية' },
    blurb: {
      en: 'Trust-first UX, reporting, and fintech flows.',
      ar: 'واجهات موثوقة وتقارير دقيقة وتدفقات مالية آمنة.',
    },
  },
  {
    id: 'manufacturing',
    icon: 'Factory',
    title: { en: 'Manufacturing', ar: 'التصنيع' },
    blurb: {
      en: 'ERP-aligned systems and production visibility.',
      ar: 'أنظمة متوافقة مع ERP ورؤية واضحة لخطوط الإنتاج.',
    },
  },
  {
    id: 'services',
    icon: 'Briefcase',
    title: { en: 'Services', ar: 'خدمات الأعمال' },
    blurb: {
      en: 'Agency & B2B sites that convert inquiries.',
      ar: 'مواقع للشركات وB2B تحوّل الاستفسارات إلى فرص عمل.',
    },
  },
];
